var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 6.87435V14.9993C16.6663 17.4993 15.1747 18.3327 13.333 18.3327H6.66634C4.82467 18.3327 3.33301 17.4993 3.33301 14.9993V6.87435C3.33301 4.16602 4.82467 3.54102 6.66634 3.54102C6.66634 4.05768 6.87465 4.52435 7.21632 4.86601C7.55799 5.20768 8.02467 5.41602 8.54134 5.41602H11.458C12.4913 5.41602 13.333 4.57435 13.333 3.54102C15.1747 3.54102 16.6663 4.16602 16.6663 6.87435Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 3.54102C13.3337 4.57435 12.492 5.41602 11.4587 5.41602H8.54199C8.02533 5.41602 7.55864 5.20768 7.21697 4.86601C6.8753 4.52435 6.66699 4.05768 6.66699 3.54102C6.66699 2.50768 7.50866 1.66602 8.54199 1.66602H11.4587C11.9753 1.66602 12.442 1.87435 12.7837 2.21602C13.1253 2.55769 13.3337 3.02435 13.3337 3.54102Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 10.834H10.0003",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 14.166H13.3337",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.0ed2a00e22a02471764e833c6bd711f7.svg";
export { ForwardRef as ReactComponent };